import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import FetchData from "../../providers/dataProvider";
import { formatDate } from "../../utils/Validate";

const ViewProject = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [viewItem, setViewItem] = useState(null);

  const {
    data: designationdata,
    loading: designationLoading,
    error: designationError,
  } = FetchData("designation");

  useEffect(() => {
    if (location?.state) {
      const item = location?.state;
      const itemCopy = { ...item };
      if (itemCopy) {
        itemCopy?.projectContacts?.map((obj) => {
          const designationObj = designationdata?.find(
            (el) => el?.id == obj?.designationId
          );
          if (designationObj)
            obj["designationName"] = designationObj?.designationName;
          else obj["designationName"] = "";

          return obj;
        });
      }
      setViewItem(itemCopy);
    } else {
      navigate("/project-master");
    }
  }, [location?.state, designationdata]);

  return (
    <div className="container-fluid view-project-sec">
      <section className="project-view-sec mt-2">
        <div className="row">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="card mb-2">
              <div className="card-header pl-3">
                <div class="d-flex justify-content-start align-items-center w-100 flex-wrap">
                  <Link to="/project-master">
                    <button className="btn p-0 mr-2" type="button">
                      <i class="fas fa-angle-left"></i>
                    </button>
                  </Link>
                  <h1> General</h1>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Project Name</h5>
                      <h6>{viewItem?.projectName}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Project Segment</h5>
                      <h6>{viewItem?.ProjectSegment}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Project Status</h5>
                      <h6>{viewItem?.ProjectStatus}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>MEP Contractor</h5>
                      <h6>{viewItem?.MEPCustomer}</h6>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Main Contractor</h5>
                      <h6>{viewItem?.MainCustomer}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Design Consultant</h5>
                      <h6>{viewItem?.DesignCustomer}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Supervision Consultant</h5>
                      <h6>{viewItem?.SuperCustomer}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Distributor</h5>
                      <h6>{viewItem?.Distributor}</h6>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Client</h5>
                      <h6>{viewItem?.ClientCustomer}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Country</h5>
                      <h6>{viewItem?.Country}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Project Start Date</h5>
                      <h6>{formatDate(viewItem?.startDate)}</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4">
                    <div>
                      <h5>Project End Date</h5>
                      <h6>{formatDate(viewItem?.endDate)}</h6>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xxl-9 col-xl-9 col-lg-9 col-md-8 col-sm-6 col-xs-12">
                    <div>
                      <h5>Additional Info</h5>
                      <h6>{viewItem?.additionalInfo}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card mb-2">
              {viewItem?.subContractors?.length > 0 && (
                <><div className="card-header pl-3">
                  <h1>Additional Sub Contractors</h1>
                </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pl-0">
                        <table class="table table-borderless">
                          <thead>
                            <tr>
                              <td scope="col">Sl. No</td>
                              <td scope="col">Contractor name</td>
                            </tr>
                          </thead>
                          <tbody>
                            {viewItem?.subContractors?.map((obj, index) => (
                              <tr>
                                <th scope="row">{index * 1 + 1}</th>
                                <th>{obj?.subContractorName}</th>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div></>)}
            </div>
            <div className="card mb-2">
              <div className="card-header pl-3">
                <h1>Contacts</h1>
              </div>
              <div className="card-body">
                <div className="row mt-2 contact-view-area">
                  {viewItem?.projectContacts?.length > 0 ? (
                    viewItem?.projectContacts?.map((obj) => (
                      <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-12 col-xs-12 mb-2">
                        <div className="view-contact">
                          <i className="far fa-user-circle"></i>
                          <h5>{obj?.name}</h5>
                          <span>{obj?.email}</span>
                          <p>{obj?.designationName}</p>
                          <p>{obj?.phone}</p>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2 no-contact">
                      <p>No contacts avilable</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-4 mb-4">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="text-right mob-mt-13 mob-mb-15">
              <Link to="/project-master">
                <button className="btn back-btn" type="button">
                  Back
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ViewProject;
